var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      !_vm.success
        ? _c(
            "a",
            {
              staticClass: "gfu-link gfu-link--inline gfu-link--nofx",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.copyText.apply(null, arguments)
                },
              },
            },
            [_c("base-icon", { attrs: { name: "link" } })],
            1
          )
        : _c(
            "tooltip",
            {
              ref: "tooltip",
              attrs: {
                text: "Copied to clipboard!",
                theme: _vm.light ? "light" : "default",
                "vertical-position": _vm.verticalPosition,
              },
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "gfu-link gfu-link--nofx gfu-link--block gfu-link--inline _tc--accent",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.copyText.apply(null, arguments)
                    },
                  },
                },
                [_c("base-icon", { attrs: { name: "link" } })],
                1
              ),
            ]
          ),
      _vm._v(" "),
      _c("input", {
        ref: "copyLinkInput",
        staticClass: "gfu-countdown__hidden-link",
        attrs: { type: "text", "aria-hidden": "true" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }